








































































































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import AppModal from "../../../shared/components/ui/Modal.vue"

@Component({
    components: {
        AppModal
    },
})
export default class ChooseCaptain extends Vue {
    @Prop() lineUp: any;
    private open = true;
    private selectedCaptain = null;
    private selectedSubCaptain = null;

    close() {
       this.$emit('close');
    }

    mounted() {
    }

    submit() {
      this.$emit("submit", {selectedCaptain: this.selectedCaptain, selectedSubCaptain: this.selectedSubCaptain})
    }
}
